// extracted by mini-css-extract-plugin
export default {"section":"WrapperFiltroSection_section__YWTpR","title":"WrapperFiltroSection_title__ETebI"};